module.exports = __webpack_public_path__ + "images/home/product/mobile/features-report-03e2771b3d9fe3ab7f6b6154c4ce0471.png";